import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import {SpacGrid} from '../component/index';

const SpacPage = () => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>SPAC</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <SpacGrid />
    </>
  );
};

export default SpacPage;
